"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EngagementTypes = void 0;
var EngagementTypes;
(function (EngagementTypes) {
    EngagementTypes["GALLERY_SWIPE"] = "GALLERY_SWIPE";
    EngagementTypes["VIDEO_WATCH"] = "VIDEO_WATCH";
    EngagementTypes["VIDEO_FULLSCREEN"] = "VIDEO_FULLSCREEN";
    EngagementTypes["POST_SHARE"] = "POST_SHARE";
    EngagementTypes["POST_LIKE"] = "POST_LIKE";
    EngagementTypes["POST_COMMENT"] = "POST_COMMENT";
    EngagementTypes["POST_NAV_COMMENTS"] = "POST_NAV_COMMENTS";
    EngagementTypes["POST_NAV_LIKES"] = "POST_NAV_LIKES";
    EngagementTypes["IMPRESSION"] = "IMPRESSION";
    EngagementTypes["POST_LIGHTBOX"] = "POST_LIGHTBOX";
})(EngagementTypes = exports.EngagementTypes || (exports.EngagementTypes = {}));
